import advantageService from "../../services/advantageService/service";
import AdvantageModel from "../../models/advantageModel/model";

export default {
    async fetchAdvantage(search, page, limit, company) {
        try {
            const sanitizedSearch = search && search.trim() !== '' ? search : null;
            const {data, headers} = await advantageService.getAdvantage(sanitizedSearch, page, limit, company);
            return {
                data: data.map(advantage => new AdvantageModel(advantage)),
                total: parseInt(headers['x-total-count'], 10), // Header untuk total data
            };
        } catch (error) {
            console.error('Error fetching advantages:', error);
            throw error;
        }
    },
    async totalAllAdvantage(company) {
        try {
            return await advantageService.totalAllAdvantage(company);
        } catch (error) {
            console.error('Error fetching advantages:', error);
            throw error;
        }
    },
    async addAdvantage(advantage) {
        try {
            return await advantageService.addAdvantage(advantage);
        } catch (error) {
            console.error('Error adding advantage:', error);
            throw error;
        }
    },
    async updateAdvantage(advantage) {
        try {
            return await advantageService.updateAdvantage(advantage);
        } catch (error) {
            console.error('Error updating advantage:', error);
            throw error;
        }
    },
    async deleteAdvantage(advantageId) {
        try {
            return await advantageService.deleteAdvantage(advantageId);
        } catch (error) {
            console.error('Error deleting advantage:', error);
            throw error;
        }
    }
}